var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3536_9610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.799805,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3536_9610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 15.8538L18.1228 9.13075L17.069 8.07693L11.3998 13.7462L8.54978 10.8962L7.49595 11.95L11.3998 15.8538ZM6.1075 20.5C5.60237 20.5 5.1748 20.325 4.8248 19.975C4.4748 19.625 4.2998 19.1974 4.2998 18.6923V5.3077C4.2998 4.80257 4.4748 4.375 4.8248 4.025C5.1748 3.675 5.60237 3.5 6.1075 3.5H19.4921C19.9972 3.5 20.4248 3.675 20.7748 4.025C21.1248 4.375 21.2998 4.80257 21.2998 5.3077V18.6923C21.2998 19.1974 21.1248 19.625 20.7748 19.975C20.4248 20.325 19.9972 20.5 19.4921 20.5H6.1075Z",
    fill: "#4F46E5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxOn);
export default __webpack_public_path__ + "static/media/checkboxOn.8f8d194d5202503fe752dfafc6288a49.svg";
export { ForwardRef as ReactComponent };